"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.ServerPortal = exports.DEFAULT_PORTAL_ID = exports.createPortal = exports.flushPortals = void 0;
var common_1 = require("./common");
__createBinding(exports, common_1, "flushPortals");
__createBinding(exports, common_1, "createPortal");
__createBinding(exports, common_1, "DEFAULT_PORTAL_ID");
var ServerPortal_1 = require("./ServerPortal");
__createBinding(exports, ServerPortal_1, "default", "ServerPortal");
//# sourceMappingURL=index.js.map